<template>
  <!-- 广发银行舆情日报 -->
  <div>
    <iframe class="iframe" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "static/index.html"
    };
  }
};
</script>

<style lang="less" scoped>
.iframe {
  width: 100vw;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/H5/index.vue